import { render, staticRenderFns } from "./CreditUserDetailsDialogLimitTransactions.vue?vue&type=template&id=ad29abc4"
import script from "./CreditUserDetailsDialogLimitTransactions.vue?vue&type=script&lang=js"
export * from "./CreditUserDetailsDialogLimitTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports